var submitted = false;

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("customForm");
  const nameInput = document.getElementById("ContactFormName");
  const emailInput = document.getElementById("ContactFormEmail");
  const phoneInput = document.getElementById("ContactFormPhone");
  const companyInput = document.getElementById("ContactFormCompany");
  const qtyInput = document.getElementById("ContactFormQty");

  if (!form) return;

  form.addEventListener("submit", function (event) {
    let isValid = true;
    let messages = [];

    // ===== NAME VALIDATION =====
    const nameValue = nameInput.value.trim();

    // Check if name is empty or only spaces
    if (nameValue === "") {
      isValid = false;
      messages.push("Name is required and cannot be only spaces.");
    }
    // Check if name contains only letters and spaces (no numbers, special characters, or commas)
    else if (!/^[a-zA-Z\s]+$/.test(nameValue)) {
      isValid = false;
      messages.push(
        "Name can only contain letters and spaces (no numbers, special characters, or commas)."
      );
    }
    // Check if name has at least one letter (not just spaces)
    else if (!/[a-zA-Z]/.test(nameValue)) {
      isValid = false;
      messages.push("Name must contain at least one letter.");
    }

    // ===== EMAIL VALIDATION =====
    const emailValue = emailInput.value.trim();

    // Proper email validation: must have @ and domain with extension (e.g., .com, .org, .net)
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(emailValue)) {
      isValid = false;
      messages.push(
        "Please enter a valid email address (e.g., user@example.com)."
      );
    }

    // ===== PHONE VALIDATION =====
    const phoneValue = phoneInput.value.trim();

    // Phone must be exactly 10 digits, no negatives, no special characters
    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(phoneValue)) {
      isValid = false;
      messages.push(
        "Phone number must be exactly 10 digits (no spaces, dashes, or special characters)."
      );
    }
    // Additional check for negative numbers (in case input type allows it)
    else if (phoneValue.includes("-") || phoneValue.includes("+")) {
      isValid = false;
      messages.push("Phone number cannot contain negative or positive signs.");
    }

    // ===== COMPANY NAME VALIDATION =====
    const companyValue = companyInput.value.trim();

    // Company name is required
    if (companyValue === "") {
      isValid = false;
      messages.push("Company name is required.");
    }
    // Company name cannot be only numbers
    else if (/^\d+$/.test(companyValue)) {
      isValid = false;
      messages.push("Company name cannot contain only numbers.");
    }
    // Company name should contain at least one letter
    else if (!/[a-zA-Z]/.test(companyValue)) {
      isValid = false;
      messages.push("Company name must contain at least one letter.");
    }

    // ===== QUANTITY VALIDATION =====
   const qtyValue = qtyInput.value.trim();
  const qtyNumber = Number(qtyValue);

  // Validate quantity
  if (qtyValue === "" || isNaN(qtyNumber)) {
    isValid = false;
    messages.push("Please enter a valid quantity.");
  } else if (qtyNumber <= 0) {
    isValid = false;
    messages.push("Quantity must be at least 1.");
  } else if (qtyNumber > 9999) {
    isValid = false;
    messages.push("Quantity cannot exceed 9999.");
  }


    // ===== SUBMIT OR SHOW ERRORS =====
    if (!isValid) {
      event.preventDefault();

      // Remove any existing error message
      const existingError = document.getElementById("form-error-message");
      if (existingError) {
        existingError.remove();
      }

      // Create error message container
      const errorDiv = document.createElement("div");
      errorDiv.id = "form-error-message";
      errorDiv.style.cssText =
        "background-color: #fee; border: 2px solid #c33; color: #c33; padding: 15px; margin-bottom: 20px; border-radius: 4px; font-size: 14px;";

      // Add error heading
      const errorHeading = document.createElement("strong");
      errorHeading.textContent = "Please fix the following errors:";
      errorHeading.style.display = "block";
      errorHeading.style.marginBottom = "10px";
      errorDiv.appendChild(errorHeading);

      // Add error list
      const errorList = document.createElement("ul");
      errorList.style.cssText = "margin: 0; padding-left: 20px;";
      messages.forEach(function (message) {
        const li = document.createElement("li");
        li.textContent = message;
        li.style.marginBottom = "5px";
        errorList.appendChild(li);
      });
      errorDiv.appendChild(errorList);

      // Insert error message at the top of the form
      form.insertBefore(errorDiv, form.firstChild);

      // Scroll to error message
      errorDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // Remove error message if form is valid
      const existingError = document.getElementById("form-error-message");
      if (existingError) {
        existingError.remove();
      }
      submitted = true; // ✅ mark for iframe onload
    }
  });
});
